import { render, staticRenderFns } from "./LeagueManager.vue?vue&type=template&id=565ed5fe&scoped=true"
import script from "./LeagueManager.vue?vue&type=script&lang=js"
export * from "./LeagueManager.vue?vue&type=script&lang=js"
import style0 from "./LeagueManager.vue?vue&type=style&index=0&id=565ed5fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565ed5fe",
  null
  
)

export default component.exports